// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__SedV7","selectedAttendees":"styles_selectedAttendees__FOkiK","removeSelection":"styles_removeSelection__E19lW"};